module.exports = __webpack_public_path__ + "img/lamps.51127161.svg";